export default "__VITE_ASSET__QvR4UFyN__"